<script lang="ts" setup>
import { RenderDayCellEventArgs } from "@syncfusion/ej2-calendars";
import { globalsBezeichnung, begriffBezeichnung } from "@/local";
import { Globals } from "@/Globals";

import {
  getDateFromInput,
  getMask,
  highlightDays,
  valueToFormatStr,
  getHolidayColorVuetify,
} from "./CalenderHelper";
import { findSperrDate } from "@/SperreHelper";

import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
import MaskedInput from "./MaskedInput.vue";
import { get } from "http";
import { reactive, onMounted, nextTick, ref } from "vue";
import AUApi from "@/api";
import { useRegisterValidation } from "@/components/EditorValidator";
declare interface EditDateRangeControlProps extends EditControlProps {
  sperrBegriff?: string;
}
declare interface EditDateRangeUiData extends EditorControlUiData {
  von?: Date;
  bis?: Date;
  pickerDates: string[]; // = [];
  showPicker: boolean; // = false;

  vonStr: string; // = ""; // String Anzeige
  bisStr: string; // = "";

  minDate?: Date;

  vonError: string; // = "";
  bisError: string; // = "";

  IsAllDay: boolean; // = true;
  allDayVisible: boolean; // = true;
  showFields: boolean; // = true;
  mask: string; // = "D1.M1.1111";

  calendarVal: string; // = "";
  dateFormat: string; // = "dd-MM-yyyy";
  format: string; // = "dd.MM.yyyy";

  allDayFormat: string; // = "dd.MM.yyyy";
  notAllDayFormat: string; // = "HH:mm dd.MM.yyyy";

  pickertitle: string; // = "Wählen sie ein Start-Datum:";
  selectinVon: boolean; // = true;
  changing: boolean; //= false;

  ignoreNextPickerEvents: number; // = 2;
  iconCss: string; // = "";
  showTooltip: boolean; // = false;
  tooltipText: string; // = "";
}

const props = defineProps<EditDateRangeControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

const { config, ui } = getDefaultEditorControlConfig<
  EditorControlConfig,
  EditDateRangeControlProps,
  EditDateRangeUiData
>(props, emitFn, {
  // default start values
  pickerDates: [],
  showPicker: false,

  vonStr: "", // String Anzeige
  bisStr: "",

  vonError: "",
  bisError: "",

  IsAllDay: true,
  allDayVisible: true,
  showFields: true,
  mask: "D1.M1.1111",

  calendarVal: "",
  dateFormat: "dd.MM.yyyy",
  format: "dd.MM.yyyy",

  allDayFormat: "dd.MM.yyyy",
  notAllDayFormat: "HH:mm dd.MM.yyyy",

  pickertitle: "Wählen sie ein Start-Datum:",
  selectinVon: true,
  changing: false,

  ignoreNextPickerEvents: 2,
  iconCss: "",
  showTooltip: false,
  tooltipText: "",
});
const uiData = reactive(ui);
config.validate = validate;
useRegisterValidation({ config });
let initalized = ref<boolean>(false);
onMounted(async () => {
  initalized.value = false;
  mounted(uiData, props, config);
  await mountedDateRange();
});

/* presets */
const weekStart: any = new Date(
  new Date(
    new Date().setDate(new Date().getDate() - ((new Date().getDay() + 7) % 7))
  ).toDateString()
);
const weekEnd: any = new Date(
  new Date(
    new Date().setDate(
      new Date(
        new Date().setDate(new Date().getDate() - ((new Date().getDay() + 7) % 7))
      ).getDate() + 6
    )
  ).toDateString()
);
// private monthStart: any = new Date(
//   new Date(new Date().setDate(1)).toDateString()
// );
// private monthEnd: any = new Date(
//   new Date(
//     new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)
//   ).toDateString()
// );
// private lastStart: any = new Date(
//   new Date(
//     new Date(new Date().setMonth(new Date().getMonth() - 1)).setDate(1)
//   ).toDateString()
// );
// private lastEnd: any = new Date(
//   new Date(new Date().setDate(0)).toDateString()
// );
// private yearStart: any = new Date(
//   new Date(new Date().getFullYear() - 1, 0, 1).toDateString()
// );
// private yearEnd: any = new Date(
//   new Date(new Date().getFullYear() - 1, 11, 31).toDateString()
// );

// bitte die nächsten x events vom picker ignorieren weil der grad von uns gefeuert wird ;)

function selectedDatesText() {
  if (uiData.pickerDates.length > 1) {
    const args = uiData.pickerDates;
    let bis = new Date(args[1]);
    let von = new Date(args[0]);
    if (von && bis && von > bis) {
      const x = von;
      von = bis;
      bis = x;
    }
    const diff = von.diffInDays(bis);
    const text = begriffBezeichnung("Tage");
    return diff + " " + text;
  }
  return "--";
}

async function mountedDateRange() {
  uiData.changing = true;

  if (props.sperrBegriff) {
    const sperrDate = getSperrDate(props.sperrBegriff);
    if (sperrDate) {
      uiData.minDate = new Date(sperrDate);
    }
  }
  // im data steht es richtig drinenen - auch wenn NEU Zustand ist!
  if (!uiData.data?.IsAllDay) {
    uiData.IsAllDay = false;
  }

  if (uiData.IsAllDay) {
    uiData.format = uiData.allDayFormat;
  } else {
    uiData.format = uiData.notAllDayFormat;
  }
  uiData.mask = getMask(uiData.format);
  const val = config.initValue;
  if (val) {
    if (val.IsAllDay === true) {
      if (val.von) {
        val.von = new Date(
          new Date(new Date(val.von).setHours(0)).setMinutes(0)
        ).toISOStringWithTZGMT();
      }
      if (val.bis) {
        val.bis = new Date(
          new Date(new Date(val.bis).setHours(0)).setMinutes(0)
        ).toISOStringWithTZGMT();
      }
    }
    if (val.von) {
      uiData.von = new Date(val.von);
      uiData.vonStr = valueToFormatStr(uiData.von, uiData.format);
    }
    if (val.bis) {
      uiData.bis = new Date(val.bis);
      let bisDisplay;
      if (val.von !== val.bis) {
        if (uiData.IsAllDay) {
          bisDisplay = uiData.bis = new Date(val.bis).addDays(-1);
        } else {
          bisDisplay = new Date(val.bis);
        }
      } else {
        bisDisplay = uiData.bis;
      }
      uiData.bisStr = valueToFormatStr(bisDisplay, uiData.format);

      uiData.bisStr = valueToFormatStr(bisDisplay, uiData.format);
    }
  }

  if (uiData.von && uiData.bis) {
    uiData.pickerDates = [uiData.von.toISOStringWithTZ(), uiData.bis.toISOStringWithTZ()];
  } else if (uiData.von) {
    uiData.pickerDates = [uiData.von.toISOStringWithTZ(), uiData.von.toISOStringWithTZ()];
  } else {
    uiData.pickerDates = [];
  }
  // in der Datumsauswahl muss ich auch einen tag wegnehmen - damit es zusammenpasst!

  await setPickerDates();

  uiData.ignoreNextPickerEvents = 2;
  nextTick(() => ((uiData.changing = false), (initalized.value = true)));
}

async function setPickerDates(removeFromBis: boolean = false) {
  if (uiData.von && uiData.bis) {
    const bis = removeFromBis ? uiData.bis.addDays(-1) : uiData.bis;
    uiData.pickerDates = [
      uiData.von.toISOStringWithTZ().substring(0, 10),
      bis.toISOStringWithTZ().substring(0, 10),
    ];
  } else if (uiData.von) {
    uiData.pickerDates = [
      uiData.von.toISOStringWithTZ().substring(0, 10),
      uiData.von.toISOStringWithTZ().substring(0, 10),
    ];
  }
}

function allDayChanged(args: boolean) {
  try {
    // console.log("allDayChanged " + JSON.stringify(args));
    const von = getDateFromInput(uiData.vonStr, uiData.format);
    const bis = getDateFromInput(uiData.bisStr, uiData.format);

    uiData.showFields = false;
    uiData.IsAllDay = args;
    if (uiData.IsAllDay) {
      uiData.format = uiData.allDayFormat;
    } else {
      uiData.format = uiData.notAllDayFormat;
    }
    uiData.mask = getMask(uiData.format);
    uiData.vonStr = "";
    uiData.bisStr = "";
    nextTick(() => {
      uiData.showFields = true;
      if (
        von.date &&
        von.date.toISOStringWithTZ().substring(0, 16) !== "1970-01-01T00:00"
      ) {
        uiData.vonStr = valueToFormatStr(von.date, uiData.format);
      }
      if (
        bis.date &&
        bis.date.toISOStringWithTZ().substring(0, 16) !== "1970-01-01T00:00"
      ) {
        uiData.bisStr = valueToFormatStr(bis.date, uiData.format);
      }
    });
    rangeChanged();
  } catch (e) {
    console.error(e);
  }
}

function vonChanged(x: any, fire: boolean = true) {
  console.log("von...");
  try {
    const val = getDateFromInput(x, uiData.format);
    // console.log(x + " -> " + val);
    if (val) {
      if (val.date) {
        uiData.von = val.date;
        if (uiData.minDate) {
          if (!uiData.von || uiData.von < uiData.minDate) {
            const minDateStr = uiData.minDate.toISOStringWithTZ().substring(0, 10);
            val.error = "ab" + " " + minDateStr;
          }
        }
      }
      if (val.error) {
        uiData.vonError = val.error;
        fire = false; // nicht event feuern weil ungültig...
      } else {
        uiData.vonError = "";
      }
    }
    if (fire) {
      rangeChanged();
    }
  } catch (e) {
    console.error(e);
  }
}
function bisChanged(x: any, fire: boolean = true) {
  console.log("bis...");
  try {
    const val = getDateFromInput(x, uiData.format);
    // console.log(x + " -> " + val);
    if (val) {
      if (val.date) {
        uiData.bis = val.date;
        //  if (uiData.maxDate) {
        //   if (uiData.bis > uiData.maxDate) {
        //     const maxDateStr = uiData.maxDate
        //       .toISOStringWithTZ()
        //       .substring(0, 10);
        //     val.error = "bis" + " " + maxDateStr;
        //   }
        // }
      }
      if (val.error) {
        uiData.bisError = val.error;
        fire = false; // nicht event feuern weil ungültig...
      } else {
        uiData.bisError = "";
      }
    }

    if (fire) {
      rangeChanged();
    }
  } catch (e) {
    console.error(e);
  }
}

function validate(): boolean {
  try {
    if (uiData.readonly) return true;
    if (
      (uiData.vonError && uiData.vonError.length > 0) ||
      (uiData.bisError && uiData.bisError.length > 0)
    ) {
      return false;
    }
    return true;
  } catch (error) {
    console.log(error);
  }
  return false;
}

async function rangeChanged() {
  let von = null;
  let bis = null;
  if (uiData.von) {
    von = uiData.von.toISOStringWithTZ();
  }
  // if (!uiData.IsAllDay && uiData.von) {
  //   // bis = von;
  //   bis = uiData.von.toISOStringWithTZ();
  //   uiData.vonPicker = uiData.von;
  //   // uiData.bisPicker = uiData.von;
  // }
  if (uiData.bis) {
    bis = uiData.bis.toISOStringWithTZ();
  }
  if (uiData.von && uiData.bis && uiData.von > uiData.bis) {
    uiData.bisError = "von > bis !";
    // ups abbrechen
    return;
  } else {
    uiData.bisError = "";
  }

  await setPickerDates();

  const val = {
    von,
    bis,
    IsAllDay: uiData.IsAllDay,
  };
  // 13.7.2020 das darf ich nicht machen - sonst hab ich bei MANUELLER eingabe einen Tag zu viel!
  // if (uiData.IsAllDay && bis) {
  //   val.bis = new Date(bis).addDays(1).toISOStringWithTZ();
  // }

  console.log(JSON.stringify(val));
  valueChangedRange(val);
}

function valueChangedRange(val: any) {
  if (val && val.IsAllDay) {
    if (val.von) {
      val.von = new Date(val.von).asLocalDateString();
    }
    if (val.bis) {
      val.bis = new Date(val.bis).addDays(1);
      val.bis = new Date(val.bis).asLocalDateString();
    }
  }
  valueChanged(config, uiData, val);
}

function closePicker(saveValue: boolean) {
  uiData.showPicker = false;
  if (saveValue) {
    const von =
      uiData.pickerDates.length > 0 ? new Date(uiData.pickerDates[0]) : undefined;
    const bis =
      uiData.pickerDates.length > 1 ? new Date(uiData.pickerDates[1]) : undefined;
    setVonBis(von, bis);
  }
}
function pickerPicked(args: any) {
  // if (uiData.ignoreNextPickerEvents > 0) {
  //   uiData.ignoreNextPickerEvents--;
  //   return;
  // }
  /*
  if (uiData.changing) {
    uiData.changing = false; // ich muss wieder zurücksetzen -
    // weil wenn zuerst manuell und dann über den Picker erfasst wird - braucht er changibg wieder auf False
    return;
  }

  uiData.changing = true;
  // const von = args.startDate;
  // const bis = args.endDate;
  let von = args.length > 0 ? new Date(args[0]) : null;
  let bis = args.length > 1 ? new Date(args[1]) : null;

  setVonBis(von, bis);
  */
}

function setVonBis(von?: Date, bis?: Date) {
  uiData.showFields = false;
  if (von && bis && von > bis) {
    const x = von;
    von = bis;
    bis = x;
  }

  let isodate = "";
  if (uiData.von) {
    isodate += uiData.von.toISOStringWithTZ().substring(0, 10); // nur das datum ;)
  }
  if (uiData.bis) {
    isodate += uiData.bis.toISOStringWithTZ().substring(0, 10);
  }

  // falls vorhanden Uhrzeit und von geschriebenem übertragen
  if (von) {
    if (uiData.von) {
      von.setHours(uiData.von.getHours());
      von.setMinutes(uiData.von.getMinutes());
    }
  }
  if (bis) {
    if (uiData.bis) {
      bis.setHours(uiData.bis.getHours());
      bis.setMinutes(uiData.bis.getMinutes());
    }
  }

  let isodateval = "";
  if (von) {
    isodateval += von.toISOStringWithTZ();
  }
  if (bis) {
    isodateval += bis.toISOStringWithTZ();
  }

  if (isodate !== isodateval) {
    uiData.vonStr = von ? valueToFormatStr(von, uiData.format) : "";
    uiData.von = von;
    uiData.bisStr = bis ? valueToFormatStr(bis, uiData.format) : "";
    uiData.bis = bis;
  }
  nextTick(() => {
    uiData.showFields = true;
    if (uiData.von && uiData.bis) {
      valueChangedRange({
        von: uiData.von.toISOStringWithTZ(),
        bis: uiData.bis.toISOStringWithTZ(),
        IsAllDay: uiData.IsAllDay,
      });
    } else if (uiData.von) {
      valueChangedRange({
        von: uiData.von.toISOStringWithTZ(),
        bis: null,
        IsAllDay: uiData.IsAllDay,
      });
    } else if (uiData.bis) {
      valueChangedRange(null);
    }
    uiData.changing = false; // muss zurück gesetzt werden! sonst geht keine Änderung über den DatePicker mehr!
  });
}

function getHolidayColorVuetifyUI(args: string) {
  try {
    return getHolidayColorVuetify(new Date(args)) ?? "";
  } catch (err) {
    console.error(err);
  }
}

function onDayHover(day: string) {
  const feiertag = AUApi.Current.getHoliday(day);
  if (feiertag) {
    uiData.showTooltip = true;
    uiData.tooltipText = feiertag.bezeichnung;
  }
}
function onDayLeave(args: any) {
  uiData.showTooltip = false;
}

function highlightDaysUI(args: RenderDayCellEventArgs): void {
  try {
    return highlightDays(args);
  } catch (err) {
    console.error(err);
  }
}
function getSperrDate(begriff: any) {
  const aic = AUApi.Current.user.aic;
  if (props.query) {
    const t = findSperrDate(props.query, aic);
    if (t) {
      const sperrDate = t.sperrDate;
      return new Date(sperrDate);
    }
  }
}
</script>
<template>
  <v-container v-if="uiData.showMutable" class="wrap">
    <v-row align-start class="pa-0" style="max-height: 30px">
      <v-col cols="5" class="fullcol">
        <MaskedInput
          :disabled="uiData.disabled"
          v-if="uiData.showFields"
          ref="von"
          :label="globalsBezeichnung(Globals.Begriff, 'von', 'von')"
          v-model="uiData.vonStr"
          :errorText="uiData.vonError"
          :mask="uiData.mask"
          @update:modelValue="vonChanged"
          @change="vonChanged"
        />
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </v-col>
      <v-col cols="5" class="fullcol">
        <MaskedInput
          :disabled="uiData.disabled"
          v-if="uiData.showFields"
          ref="bis"
          :label="globalsBezeichnung(Globals.Begriff, 'bis', 'bis')"
          v-model="uiData.bisStr"
          :errorText="uiData.bisError"
          :mask="uiData.mask"
          @update:modelValue="bisChanged"
          @change="bisChanged"
        />
        <ValueChangeTracker v-if="uiData.isChanged || props.disableValueChangeTracker" />
      </v-col>
      <v-col cols="2" align-self="center" class="fullcol">
        <v-menu
          :close-on-click="true"
          :close-on-content-click="false"
          :offset-y="true"
          v-model="uiData.showPicker"
        >
          <template v-slot:activator="{ props }">
            <v-btn
              v-if="!uiData.disabled"
              variant="text"
              align-self="center"
              v-bind="props"
            >
              <v-icon :class="uiData.iconCss">mdi-clock-outline</v-icon>
            </v-btn>
          </template>

          <div style="background: white">
            <v-tooltip
              :disabled="!uiData.showtooltip"
              location="top"
              v-model="uiData.showTooltip"
              nudge-top="-55"
              max-width="300px"
              :text="uiData.tooltipText"
            >
              <template v-slot:activator="{ props }">
                <v-date-picker
                  v-model="uiData.pickerDates"
                  multiple="range"
                  locale="de-de"
                  :min="uiData.minDate"
                  first-day-of-week="1"
                  :show-week="true"
                  :selected-items-text="selectedDatesText"
                  @mouseover:date="onDayHover"
                  @mouseleave:date="onDayLeave"
                  v-bind="props"
                ></v-date-picker>
              </template>
            </v-tooltip>
            <v-spacer></v-spacer>
            <div style="text-align: right">
              <v-btn variant="text" @click="closePicker(false)">
                {{ begriffBezeichnung("Close") }}</v-btn
              >
              <v-btn color="primary" flat @click="closePicker(true)"> Ok </v-btn>
            </div>
          </div>
        </v-menu>
      </v-col>
    </v-row>

    <!-- <v-row class="pt-3">
      <v-col cols="12" align-self="center" class="fullcol">
        <v-checkbox
          :disabled="uiData.disabled"
          v-model="uiData.IsAllDay"
          :label="
            globalsBezeichnung(Globals.Begriff, 'Web_ganztaegig', 'ganztägig')
          "
          @change="allDayChanged"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row> -->
  </v-container>
</template>
<style scoped>
.fullcol {
  width: 100%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 5px;
}

.rotateIcon {
  /* transform: rotate(90deg); */
  color: green !important;
  /* color: red; */
}

.rangeDateHighlight {
  border-top: 3px solid #4f4 !important;
  background-color: #cfc !important;
}
</style>
